import React, { useEffect, useState } from 'react';
import { Menu, X, Search, User } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Companions',
    href: '#companions'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-[#0a0a0a]/90 backdrop-blur-md border-b border-[#c9a96e]/20 py-4' : 'bg-transparent py-6'}`} data-id="element-168">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-169">
        {/* Logo */}
        <div className="flex items-center gap-2" data-id="element-170">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#c9a96e] to-[#8a7035] flex items-center justify-center text-black font-serif font-bold text-lg" data-id="element-171">
            S
          </div>
          <span className="text-2xl font-serif font-bold text-white tracking-wide" data-id="element-172">
            后宫 <span className="text-[#c9a96e]" data-id="element-173">SGHarem</span>
          </span>
        </div>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8" data-id="element-174">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm uppercase tracking-widest text-neutral-400 hover:text-[#c9a96e] transition-colors duration-300" data-id="element-175">
              {link.name}
            </a>)}
        </div>

        {/* Actions */}
        <div className="hidden md:flex items-center gap-4" data-id="element-176">
          <button className="p-2 text-neutral-400 hover:text-[#c9a96e] transition-colors" data-id="element-177">
            <Search size={20} data-id="element-178" />
          </button>
          <button className="px-5 py-2 border border-[#c9a96e]/50 text-[#c9a96e] rounded-full text-sm hover:bg-[#c9a96e] hover:text-black transition-all duration-300" data-id="element-179">
            Login
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-180">
          {isMobileMenuOpen ? <X size={24} data-id="element-181" /> : <Menu size={24} data-id="element-182" />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-183">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-[#111111] border-b border-[#c9a96e]/20 p-6 md:hidden flex flex-col gap-4 shadow-2xl" data-id="element-184">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg font-serif text-neutral-300 hover:text-[#c9a96e] py-2 border-b border-neutral-800" data-id="element-185">
                {link.name}
              </a>)}
            <div className="flex gap-4 mt-4" data-id="element-186">
              <button className="flex-1 py-3 border border-[#c9a96e] text-[#c9a96e] rounded-lg text-center" data-id="element-187">
                Login
              </button>
              <button className="flex-1 py-3 bg-[#c9a96e] text-black rounded-lg text-center font-medium" data-id="element-188">
                Sign Up
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}